export class DashboardConstants {
    static PHASES_HEADING = "Application status";
    static DEFAULT_COLUMN = "default";
    static MODULES_SEARCH_PLACEHOLDER_TEXT = "Filter modules";
    static APPLICATONS = "Applications";
    static IN_PROGRESS = "In progress";
    static UNCOMPLETED = "Incomplete";
    static OVERVIEW = "Overview";
    static HOW_IT_WORKS = "How it works";
    static AFLA_PORTAL = "Afla Portal";
    static NOTE = "Note";
}
